// extracted by mini-css-extract-plugin
export var cartContainer = "_mq-4";
export var gray = "_mq-1";
export var itemContainer = "_mq-2";
export var itemDetails = "_mq-3";
export var strong = "_mq-0";